module.exports = __webpack_public_path__ + "static/media/buy-cart.22ea5d32.svg";